import {callAPI} from '@/store/utils'; // eslint-disable-line
import {base} from './utils';

// Journals & numbering (§6 of the API contract, TT-7122). One journal object
// per code/type; `code` is free text and numbering is per (company, journal,
// fiscal_year), restarting each year. Backs the journal config behind each
// journal page's settings gear. Composed into the `accounting` namespace by
// ./index.js.
//
// NB: the macro on/off flag (bank_journal_enabled) lives on `settings` and is
// toggled via actionSetJournalEnabled (PUT /journals/<journal_type>); that is a
// different concern from these per-journal config rows.
export default {
  state: {
    journals: [],
    journalsLoaded: false,
  },
  getters: {
    journals: (state) => state.journals,
    journalsLoaded: (state) => state.journalsLoaded,
    // Journals of a given type, e.g. journalsByType('bank').
    journalsByType: (state) => (type) =>
      (state.journals || []).filter((j) => j.journal_type === type),
  },
  mutations: {
    setJournals(state, list) {
      state.journals = list || [];
      state.journalsLoaded = true;
    },
    upsertJournal(state, journal) {
      if (!journal) return;
      const i = state.journals.findIndex((j) => j.id === journal.id);
      if (i === -1) state.journals.push(journal);
      else state.journals.splice(i, 1, journal);
    },
    removeJournalById(state, id) {
      state.journals = state.journals.filter((j) => j.id !== id);
    },
  },
  actions: {
    async actionGetJournals({commit}) {
      const res = await callAPI('GET', `${base()}/journals`);
      if (res && !res.error) commit('setJournals', res.result);
      return res;
    },
    async actionCreateJournal({commit}, body) {
      const res = await callAPI('POST', `${base()}/journals`, body);
      if (res && !res.error) commit('upsertJournal', res.result);
      return res;
    },
    async actionUpdateJournal({commit}, {id, ...body}) {
      const res = await callAPI('PATCH', `${base()}/journals/${id}`, body);
      if (res && !res.error) commit('upsertJournal', res.result);
      return res;
    },
    async actionDeleteJournal({commit}, {id}) {
      const res = await callAPI('DELETE', `${base()}/journals/${id}`);
      if (res && !res.error) commit('removeJournalById', id);
      return res;
    },
    // Live numbering preview for a journal within a fiscal year (read-only, not
    // stored). fiscal_year_id is required by the backend.
    async actionGetJournalReferencePreview(_ctx, {id, fiscalYearId}) {
      return callAPI(
        'GET',
        `${base()}/journals/${id}/reference-preview?fiscal_year_id=${fiscalYearId}`,
      );
    },
  },
};
